import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthStore} from '../stores/auth.store';
import {QueryService} from '../modules/akita-mimic/services/query.service';
import {AuthState} from '../modules/akita-mimic/models/store-states/auth-state.model';

@Injectable({ providedIn: 'root' })
export class AuthQuery extends QueryService<AuthState> {
    public isLoggedIn$: Observable<boolean> = this.select('isLoggedIn');
    public token$: Observable<string> = this.select('token');
    public userId$: Observable<string> = this.select('userId');
    public fullName$: Observable<string> = this.select('fullName');

    public constructor() {
        const store = inject(AuthStore);

        super(store);
    }

    public getUsername(): string {
        return this.getValue().username;
    }

    public getFullName(): string {
        return this.getValue().fullName;
    }

    public getPassword(): string {
        return this.getValue().password;
    }

    /** @Deprecated Use getToken from authService instead **/
    public getToken(): string {
        return this.getValue().token;
    }

    public getTokenExpiresTs(): number {
        return this.getValue().tokenExpiresTs;
    }

    public getUserId(): string {
        return this.getValue().userId;
    }

    public getOrganisationId(): string {
        return this.getValue().organisationId;
    }

    public getIsLoggedIn(): boolean {
        return this.getValue().isLoggedIn;
    }

    public isRememberUser(): boolean {
        return this.getValue().rememberUser;
    }

    public hasToken(): boolean {
        return this.getValue().token?.length > 0;
    }
}
